import B2BDisposalServiceSection from "@/containers/Disposal/B2BDisposalServiceSection";
import DisposalBenefitSection from "@/containers/Disposal/DisposalBenefitSection";
import HeroSection from "@/containers/Disposal/HeroSection";
import NowRequestSection from "@/containers/Disposal/NowRequestSection";
import DisposalBenefitSecondSection from "@/containers/Disposal/DisposalBenefitSecondSection";
import { VStack } from "goi_common";
import React from "react";
import DisposalListSection from "@/containers/Disposal/DisposalListSection";
import B2BServiceDownloadSection from "@/containers/Home/B2BServiceDownloadSection";
import B2BProcessSection from "@/containers/Price/B2BProcessSection";
import Footer from "@/containers/Home/Footer";

export default function Disposal() {
  return (
    <VStack width="100%">
      <HeroSection />
      <B2BDisposalServiceSection />
      <NowRequestSection />
      <DisposalBenefitSection />
      <DisposalBenefitSecondSection />
      <DisposalListSection />
      <B2BProcessSection />
      <B2BServiceDownloadSection />
      <Footer />
    </VStack>
  );
}
